import BaseModel from './BaseModel';

class LeaseOffer extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.setApiData(data);
    this.errors = {}
  }

  setApiData = (data) => {
    this.id = data.id;
    this.name = data.name || "";
    this.no_of_emis = data.no_of_emis || "";
    this.emi_amount = data.emi_amount || "";
    this.lease_amount = parseInt(this.no_of_emis) * parseInt(this.emi_amount) || "";
    this.business_units = data.business_units || [];
    this.swap_credit_on_emi_payment = data.swap_credit_on_emi_payment || "";
    this.emi_payment_frequency_days = data.emi_payment_frequency_days || "1"
    this.is_rental = data.is_rental || false;
    this.skip_first_emi = data.skip_first_emi || false;
    this.is_activated = data.is_activated || true;
    this.user_id = data.user_id;
    this.has_emi_frequency_days = data.has_emi_frequency_days;
    this.emi_frequency_swap_count = this.has_emi_frequency_days ? this.swap_credit_on_emi_payment : "";
    this.bikes = data.bikes || [];
  }

  validations = (field) => {
    return {
      swap_credit_on_emi_payment: () => {
        if (this[field] != "" && this.field != this.emi_frequency_swap_count) {
          this.errors.swap_credit_on_emi_payment = "EMI frequency and swap credit must be same";
        }
      },
      emi_frequency_swap_count: () => {
        if (this[field] != "" && this.field != this.emi_frequency_swap_count) {
          this.errors.emi_frequency_swap_count = "EMI frequency and swap credit must be same";
        }
      }
    }[field];
  }

  toApiJson = () => {
    return {
      id: this.id,
      lease_offer: {
        id: this.id,
        name: this.name,
        tenure: this.emi_payment_frequency_days * this.no_of_emis,
        emi_amount: this.emi_amount,
        lease_amount: this.lease_amount,
        business_unit_ids: this.business_units.map((business_unit)=> business_unit.id),
        bike_ids: this.bikes.map((bike)=> bike.id),
        swap_credit_on_emi_payment: this.swap_credit_on_emi_payment,
        emi_frequency_swap_count: this.emi_frequency_swap_count,
        emi_payment_frequency_days: this.emi_payment_frequency_days,
        skip_first_emi: this.skip_first_emi,
        users_type_id: 5,
        user_id: this.user_id,
        is_online: this.is_online || true,
        is_rental: this.is_rental,
        is_activated: this.is_activated
      }
    }
  }

  validate = (field) => {
    if (this.validations(field)) {
      this.validations(field)()
    }
  }
}

export default LeaseOffer;
